module.exports = __webpack_public_path__ + "static/media/fi.2558f4e4.svg";